import axios from "axios";
import React, { useEffect, useState } from "react";
import { Header, Grid, Button } from "semantic-ui-react";
import { BaseUrl } from "../formcomponents/Constants";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
const ListCompanyNew = () => {
  //listCompany

  const navigate = useNavigate();
  useEffect(() => {
    getCompanyList();
  }, []);
  const [rowData, setrowData] = useState(null);
  const getCompanyList = async () => {
    await axios
      .get(BaseUrl + "listCompany")
      .then((res) => {
        console.log("res", res.data);
        setRecordForTable(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setRecordForTable = (record) => {
    const tempRecord = record.map(
      ({
        userId,
        companyId,
        companyName,
        ownerOrPartner,
        activities,
        typeOfCompany,
        eMailId,
      }) => ({
        userId: userId,
        companyId: companyId,
        companyName: companyName,
        ownerOrPartner: ownerOrPartner,
        activities: activities,
        eMailId: eMailId,
        typeOfCompany: typeOfCompany,
      })
    );
    setrowData(tempRecord);
  };

  const columnDefs = [
    { headerName: "Company Name ", field: "companyName" },
    { headerName: "Owner & Partner Name ", field: "ownerOrPartner" },

    { headerName: "Activities", field: "activities" },
    { headerName: "Email", field: "eMailId" },

    {
      headerName: "Edit/Delete",
      filter: false,
      field: "companyId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => updateRecord(params)}>
            <AiFillEdit />
          </Button>
          <Button color="red" onClick={() => deleteRecord(params)}>
            <AiFillDelete />
          </Button>
        </div>
      ),
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
  };

  const updateRecord = (params) => {
    // console.log("Params", params.data);
    navigate(
      `/create-company-new/${params.data.companyId}/` + params.data.userId
    );
  };

  const deleteRecord = (params) => {
    ///deleteCompany
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(BaseUrl + "deleteCompany", { companyId: params.data.companyId })
          .then((res) => {
            getCompanyList();
            console.log("res", res.data);
            Swal.fire(
              "Deleted!",
              "Company Recored has been deleted.",
              "success"
            );
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Company Details
        </Header>
      </Grid.Row>
      <br />
      <Grid.Row>
        <Button
          color="primary"
          onClick={() => navigate("/create-company-new/null/null")}
        >
          Create New
        </Button>
      </Grid.Row>
      <br />
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
          ></AgGridReact>
        </div>
      </Grid.Row>
    </div>
  );
};

export default ListCompanyNew;
